import { createFileRoute } from "@tanstack/react-router";
import { ForgotPasswordConfirmation } from "~/components/views/auth/forgot-password-confirmation";

export const Route = createFileRoute("/auth/forgot-password/confirmation")({
	component: Page,
});

function Page() {
	return <ForgotPasswordConfirmation />;
}
